import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
// PADRAO: mesmos icones do Sidebar.jsx, na cor azul (#0DAEFF).
// Audio=Mic, Nichos=Flame, Videos=TrendingUp, Insights=BarChart3, App=Download.
import { Mic, Flame, TrendingUp, BarChart3, Download } from 'lucide-react';

const BLUE = '#0DAEFF';

// Recursos REAIS da pagina de vendas, com os icones do Sidebar.
const FEATURES = [
  { icon: Mic, key: 'audio' },
  { icon: Flame, key: 'niche' },
  { icon: TrendingUp, key: 'viral' },
  { icon: BarChart3, key: 'insights' },
  { icon: Download, key: 'app' },
];

const ROTATE_MS = 2800;

const AuthBrandShowcase = () => {
  const { t } = useTranslation();
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI(p => (p + 1) % FEATURES.length), ROTATE_MS);
    return () => clearInterval(id);
  }, []);

  const F = FEATURES[i];
  const Icon = F.icon;

  return (
    <div className="dp-show">
      <div className="dp-show-stage">
        <AnimatePresence mode="wait">
          <motion.div
            key={i}
            className="dp-show-item"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -14 }}
            transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
          >
            <div className="dp-show-ico" style={{ color: BLUE, background: 'rgba(13,174,255,0.12)', borderColor: 'rgba(13,174,255,0.28)' }}>
              <Icon size={20} />
            </div>
            <div className="dp-show-txt">
              <div className="dp-show-title">{t(`login.feat_${F.key}_t`)}</div>
              <div className="dp-show-desc">{t(`login.feat_${F.key}_d`)}</div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="dp-show-dots">
        {FEATURES.map((f, idx) => (
          <button
            key={f.key}
            type="button"
            onClick={() => setI(idx)}
            className={idx === i ? 'on' : ''}
            aria-label={t(`login.feat_${f.key}_t`)}
          />
        ))}
      </div>

      <style>{`
        .dp-show { margin: 0 0 26px 0; }
        .dp-show-stage { min-height: 64px; }
        .dp-show-item { display: flex; align-items: center; gap: 14px; }
        .dp-show-ico { width: 46px; height: 46px; border-radius: 13px; display: flex; align-items: center; justify-content: center; border: 1px solid; flex-shrink: 0; }
        .dp-show-title { font-size: 16px; font-weight: 700; color: #F5F5F5; letter-spacing: -0.3px; }
        .dp-show-desc { font-size: 13.5px; color: #9A9A9A; margin-top: 2px; }
        .dp-show-dots { display: flex; gap: 7px; margin-top: 16px; }
        .dp-show-dots button { width: 7px; height: 7px; border-radius: 999px; border: none; padding: 0; cursor: pointer; background: rgba(255,255,255,0.18); transition: all 0.3s ease; }
        .dp-show-dots button.on { width: 22px; background: linear-gradient(135deg, #0DAEFF, #3B82F6); }
        @media (max-width: 900px) { .dp-show { display: none; } }
      `}</style>
    </div>
  );
};

export default AuthBrandShowcase;
